module.exports = __webpack_public_path__ + "static/GT-Super-Text-Book-4a44748b18ae557ec59b24f5824a91f5.woff";